module.exports = __webpack_public_path__ + "img/t2-media-block.535227a2.png";